function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5557 29.8211L14.2395 33.5049L21.0404 26.7039M10.5557 43.0096L14.2395 46.6934L21.0404 39.8925M25.3784 30.2349H41.5893M10.2852 18.7282H41.5893M10.2852 10.6128H21.0404M25.3784 38.5741H41.5893M25.3784 46.9133H41.5893",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.3883 57.6314C45.7264 61.2932 43.6734 63.3381 40.0114 67H2.35156V2H49.3883V57.6314Z",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0078 67.0001V55.6279H49.3881M58.7965 25.6424H67.6475M63.222 66.1968L58.7965 61.7713V16.8345H67.6475V61.7713L63.222 66.1968Z",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

function SvgCreateListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateListIcon);
export default __webpack_public_path__ + "static/media/create-list_icon.8afc3e514d5fbef1e87e7c381315a7d1.svg";
export { ForwardRef as ReactComponent };